<app-loadingoverlay *ngIf="loading"></app-loadingoverlay>

<mat-drawer-container
  class="drawer-container"
  [dir]="direction">
  <mat-drawer
    #sidebar
    class="pc-sidebar"
    [mode]="modeValue"
    opened
    [ngClass]="{
      compact: currentLayout === 'compact',
      horizontal: currentLayout === 'horizontal',
    }">
    <nav>
      <div class="navbar-wrapper">
        <div class="m-header">
          <a
            href="/"
            class="flex align-item-center">
            @if (logosvg) {
              <app-svg
                [height]="'28'"
                [url]="logosvg"></app-svg>
            } @else if (logoimage) {
              <img
                [src]="logoimage"
                alt="logo"
                class="logo-image" />
            } @else {
              <span class="logo-text">{{ title }}</span>
            }

            <a
              href="https://phoenixcoded.gitbook.io/able-pro/versioning"
              target="_blank"
              class="version">
              v{{ currentApplicationVersion }}
            </a>
          </a>
          @if (modeValue === "over") {
            <div
              class="toggle-icon"
              (click)="toggleSideDrawer()">
              <mat-icon>close</mat-icon>
            </div>
          }
        </div>
        @if (currentLayout === "vertical") {
          <app-vertical-menu [menus]="menus" />
        }
        @if (currentLayout === "compact") {
          <app-compact-menu [menus]="menus" />
        }
      </div>
    </nav>
  </mat-drawer>
  <div>
    <app-nav-bar
      [ngClass]="{
        'horizontal-navbar': currentLayout === 'horizontal',
      }" />
    @if (currentLayout === "horizontal") {
      <app-horizontal-menu
        [menus]="menus"
        [ngClass]="{
          'horizontal-menu': currentLayout === 'horizontal',
        }" />
    }
    <div class="app-container">
      <app-breadcrumb [dashboard]="true" />
      <div class="main-body">
        <div class="page-wrapper">
          <router-outlet />
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</mat-drawer-container>
<app-configuration />
